import { createRouter, createWebHistory } from 'vue-router'
import Body from '../components/BodyApp.vue'
import LoginComposition from './../components/LoginComposition.vue'
import BooksComposition from './../components/BooksComposition.vue'
import BookComposition from './../components/BookComposition.vue'
import BooksAdmin from '../components/ProductsAdmin.vue'
import CategoriasAdmin from '../components/CategoriesAdmin.vue'
import BookEdit from '../components/ProductEdit.vue'
import Users from '../components/UsersApp.vue'
import User from './../components/UserEdit.vue'
// import Security from '../components/security'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Body,
    },
    {
        path: '/login',
        name: 'LoginComposition',
        component: LoginComposition,
    },
    {
        path: '/books',
        name: 'BooksComposition',
        component: BooksComposition,
    },
    {
        path: '/books/:bookName',
        name: 'BookComposition',
        component: BookComposition,
    },
    {
        path: '/admin/productos',
        name: 'BooksAdmin',
        component: BooksAdmin,
    },
    {
        path: '/admin/categorias',
        name: 'CategoriasAdmin',
        component: CategoriasAdmin,
    },
    {
        path: '/admin/books/:productId',
        name: 'BookEdit',
        component: BookEdit,
    },
    {
        path: '/admin/users',
        name: 'Users',
        component: Users,
    },
    {
        path: '/admin/users/:userId',
        name: 'UserEdit',
        component: User,
    },
]

const router = createRouter({
    history: createWebHistory(), 
    routes
})

// this function will run every time a user navigates to any part of the site,
// and call checkToken(). If the user has a token in store.token, then we validate 
// that token.
// router.beforeEach(() => {
//     Security.checkToken();
// })

export default router